import script from "./TechnicalProperties.vue?vue&type=script&setup=true&lang=js"
export * from "./TechnicalProperties.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__